<template>
  <router-view />
</template>

<script>
export default {
  name: "purchase",
};
</script>